import AbstractFilter from './AbstractFilter.js';

export default class InsulationFilter extends AbstractFilter {
	constructor() {
		super('InsulationFilter', false);

		// Modified by setUValueOptions
		this.i18n_prefix = 'insulation_';
		this.filterOptions = {};
		this.uValue = 0.0;
	}

	setUValueOptions(uValues) {
		Object.keys(this.filterOptions).forEach(key => delete this.filterOptions[key]);
		uValues.forEach(v => (this.filterOptions[`${v.toFixed(1)}`] = 'UValueFormat'));
	}

	setFilter(filterOption) {
		this.uValue = filterOption ? parseFloat(filterOption) : 0.0;
		super.setFilter(filterOption);
	}

	applyFilter(dbView) {
		super.applyFilter(dbView);
		if (this.selectedFilter === null) {
			return;
		}

		let match = [];
		for (var i = 0; i < dbView['uValue']['1-glazed'].length; ++i) {
			let uVal = dbView['uValue']['1-glazed'][i].u_value;
			if (uVal == this.uValue) {
				match.push(dbView['uValue']['1-glazed'][i]);
			} else {
				dbView['uValueFiltered']['1-glazed'].push(dbView['uValue']['1-glazed'].splice(i, 1)[0]);
				i -= 1;
			}
		}
		dbView['uValue']['1-glazed'] = [...match];

		match = [];
		for (var i = 0; i < dbView['uValue']['2-glazed'].length; ++i) {
			let uVal = dbView['uValue']['2-glazed'][i].uValue;
			if (uVal == this.uValue) {
				match.push(dbView['uValue']['2-glazed'][i]);
			} else {
				dbView['uValueFiltered']['2-glazed'].push(dbView['uValue']['2-glazed'].splice(i, 1)[0]);
				i -= 1;
			}
		}
		dbView['uValue']['2-glazed'] = [...match];

		match = [];
		for (var i = 0; i < dbView['uValue']['3-glazed'].length; ++i) {
			let uVal = dbView['uValue']['3-glazed'][i].uValue;
			if (uVal == this.uValue) {
				match.push(dbView['uValue']['3-glazed'][i]);
			} else {
				dbView['uValueFiltered']['3-glazed'].push(dbView['uValue']['3-glazed'].splice(i, 1)[0]);
				i -= 1;
			}
		}
		dbView['uValue']['3-glazed'] = [...match];
	}
}
